import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { fetchCommandesClientPourVendeur } from '../../../services/commande.js';
import '../../../styles/vendeurs/CommandesVendeurs.css';

function CommandesVendeur() {
  const [commandes, setCommandes] = useState([]);
  
    const [currentPage, setCurrentPage] = useState(1);
    const commandesParPage = 15;
    const [searchParams] = useSearchParams();
    const idCommande = searchParams.get('idCommande');

    const [filtreTexte, setFiltreTexte] = useState('');
    const [filtreDate, setFiltreDate] = useState('');

    const indexOfLastCommande = currentPage * commandesParPage;
    const indexOfFirstCommande = indexOfLastCommande - commandesParPage;
      const commandesFiltrées = commandes.filter(c => {
        const texte = filtreTexte.toLowerCase();
        const correspondTexte =
          c.nom_client?.toLowerCase().includes(texte) ||
          c.prenom_client?.toLowerCase().includes(texte) ||
          c.titre_produit?.toLowerCase().includes(texte) ||
          c.categorie_produit?.toLowerCase().includes(texte);

        const correspondDate = filtreDate
          ? new Date(c.date).toLocaleDateString('fr-CA') === filtreDate
          : true;

        return correspondTexte && correspondDate;
      });

      const commandesVisibles = commandesFiltrées.slice(indexOfFirstCommande, indexOfLastCommande);


      useEffect(() => {
        const vendeur = JSON.parse(localStorage.getItem('vendeurConnecte'));
        const commandeNotifiée = localStorage.getItem('commandeNotifiée');

        if (vendeur?.id) {
          fetchCommandesClientPourVendeur(vendeur.id).then((data) => {
            if (commandeNotifiée) {
              const filtered = data.filter((c) => c.commande_id === parseInt(commandeNotifiée));
              setCommandes(filtered);
              localStorage.removeItem('commandeNotifiée'); // nettoie
            } else {
              setCommandes(data);
            }
          });
        }
      }, []);

      console.log("Commande surlignée :", idCommande);

  return (
    <div className="commandes-container">
      <h2>📦 Commandes de mes clients</h2>
      <div className="filtres-commandes">
        <input
          type="text"
          placeholder="🔍 Nom du client ou produit"
          value={filtreTexte}
          onChange={(e) => setFiltreTexte(e.target.value)}
        />
        <input
          type="date"
          value={filtreDate}
          onChange={(e) => setFiltreDate(e.target.value)}
        />
      </div>

     {commandes.length === 0 ? (
  <p>Aucune commande payée pour l’instant.</p>
            ) : (
              <div className="table-responsive"> {/* ✅ AJOUT ICI */}
                <table className="mes-produits-table"> {/* ✅ CHANGE le nom de classe */}
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Client</th>
                      <th>Téléphone</th>
                      <th>Produit</th>
                      <th>Quantité</th>
                      <th>Prix unitaire</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {commandesVisibles.map((c, i) => (
                      <tr
                        key={i}
                        className={idCommande && parseInt(idCommande) === c.commande_id ? "ligne-notification" : ""}
                      >
                        <td data-label="Date">{new Date(c.date).toLocaleDateString()}</td>
                        <td data-label="Client">{c.nom_client} {c.prenom_client}</td>
                        <td data-label="Téléphone">{c.telephone_client}</td>
                        <td data-label="Produit">{c.titre_produit} ({c.categorie_produit})</td>
                        <td data-label="Quantité">{c.quantite} {c.unite}</td>
                        <td data-label="Prix unitaire">{c.prix_unitaire} Ar</td>
                        <td data-label="Total">{(c.quantite * c.prix_unitaire).toFixed(2)} Ar</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          <div className="pagination">
              {Array.from({ length: Math.ceil(commandesFiltrées.length / commandesParPage) }).map((_, i) => (
              <button
                key={i}
                className={i + 1 === currentPage ? 'active' : ''}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}
          </div>
    </div> 
  );
}

export default CommandesVendeur;
